import { render, staticRenderFns } from "./SmsReport.vue?vue&type=template&id=02038038&scoped=true"
import script from "./SmsReport.vue?vue&type=script&lang=js"
export * from "./SmsReport.vue?vue&type=script&lang=js"
import style0 from "./SmsReport.vue?vue&type=style&index=0&id=02038038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02038038",
  null
  
)

export default component.exports